(() => {
  const SELECTOR = '[data-flp-guarantee-stack]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialiseGuarantee(root) {
    if (root.dataset.flpGuaranteeInitialised === 'true') return;
    root.dataset.flpGuaranteeInitialised = 'true';
    const cards = Array.from(root.querySelectorAll('[data-flp-guarantee-card]'));
    const pockets = cards.map(card => card.closest('[data-flp-guarantee-pocket]')).filter(Boolean);
    cards.forEach((card, index) => {
      card.style.setProperty('--flp-stack-index', index);
      pockets[index]?.style.setProperty('--flp-stack-index', index);
    });
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      cards.forEach((card, index) => {
        card.classList.add('is-guarantee-card-visible');
        pockets[index]?.classList.add('is-guarantee-pocket-visible');
      });
      root.style.setProperty('--flp-guarantee-progress', '1');
      return;
    }
    const setPocketState = (pocket, visible) => {
      const card = pocket.querySelector('[data-flp-guarantee-card]');
      if (pocket.classList.contains('is-guarantee-pocket-visible') !== visible) pocket.classList.toggle('is-guarantee-pocket-visible', visible);
      if (card && card.classList.contains('is-guarantee-card-visible') !== visible) card.classList.toggle('is-guarantee-card-visible', visible);
    };
    root.classList.add('flp-guarantee-motion-ready');
    const pocketObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => setPocketState(entry.target, entry.isIntersecting && entry.intersectionRatio >= .8));
    }, {threshold: [0, .25, .5, .65, .8, .95, 1]});
    pockets.forEach(pocket => pocketObserver.observe(pocket));

    let frame = 0;
    let near = false;
    let lastProgress = '';
    const writeProgress = value => {
      const next = value.toFixed(4);
      if (next === lastProgress) return;
      lastProgress = next;
      root.style.setProperty('--flp-guarantee-progress', next);
    };
    const updateState = () => {
      frame = 0;
      if (!near || !root.isConnected) return;
      const bounds = root.getBoundingClientRect();
      const travel = Math.max(1, bounds.height - window.innerHeight * .64);
      writeProgress(Math.min(1, Math.max(0, (-bounds.top + window.innerHeight * .32) / travel)));
    };
    const requestStateUpdate = () => {
      if (frame || !near) return;
      frame = window.requestAnimationFrame(updateState);
    };
    // IntersectionObserver supplies initial/restored visibility without forcing
    // layout for an offscreen section during the hero's first render.
    const rootObserver = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1];
      near = entry.isIntersecting;
      if (near) requestStateUpdate();
      else writeProgress(entry.boundingClientRect.bottom <= 0 ? 1 : 0);
    }, {rootMargin: '300px 0px'});
    rootObserver.observe(root);
    window.addEventListener('scroll', requestStateUpdate, {passive: true});
    window.addEventListener('resize', requestStateUpdate, {passive: true});
    window.addEventListener('pageshow', () => {
      rootObserver.unobserve(root); rootObserver.observe(root);
      pockets.forEach(pocket => {pocketObserver.unobserve(pocket); pocketObserver.observe(pocket);});
      requestStateUpdate();
    }, {passive: true});
    if ('ResizeObserver' in window) new ResizeObserver(requestStateUpdate).observe(root);
  }
  const boot = () => document.querySelectorAll(SELECTOR).forEach(initialiseGuarantee);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
